import {useMutation} from '@apollo/react-hooks';
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    InputAdornment,
    TextField,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Query} from 'react-apollo';
import {UrlasserDialog} from '.';
import {GET_CLUSTER_DATA, UPDATE_BRIGHTNESS_COMMAND} from './queries/dialog.queries';
import './styles/dialog.scss';

import {useQuery} from 'react-apollo';
import checkAuthorization from '../Authorization/Authorization';

import CircularProgress from '@material-ui/core/CircularProgress';

import gql from 'graphql-tag';
import {useRef} from 'react';
import {useParams} from 'react-router-dom';

const GET_CURRENT_USER = gql`
    query {
        currentUser {
            id
            username
            name
            accessAuthorizations {
                id
                canPerformActions
            }
        }
    }
`;

const GET_PROJECT = gql`
    query central($id: String!) {
        central(id: $id) {
            id
            project_id
        }
    }
`;

const DATA_POLL_INTERVAL = 1000;

const SwitchBrightnessDialog = props => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////
    const {centralID} = useParams();
    const {data: currentUserData} = useQuery(GET_CURRENT_USER, {fetchPolicy: 'cache-first'});
    const {data: currentProject} = useQuery(GET_PROJECT, {variables: {id: centralID}});
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const {source, open, onClose, onVerifyClick} = props;
    const [openUrlasserDialog, setOpenUrlasserDialog] = useState(false);
    const [values, setValues] = React.useState({});
    const [changeBrightness] = useMutation(UPDATE_BRIGHTNESS_COMMAND);
    const [autoModeActive, setAutoModeActive] = React.useState({});

    const [initialValue, setInitialValue] = useState(true);
    const [initialCheck, setInitialCheck] = useState(true);

    const initialValues = useRef({});
    const initialChecks = useRef({});

    let allCluster = [];

    if (open) {
        source.crosssections.forEach(crosssection => {
            crosssection.ssts.forEach(sst => {
                sst.cluster.forEach(cluster => {
                    allCluster.push(cluster);
                });
            });
        });
    }

    const handleUrlasserDialogClose = () => {
        setOpenUrlasserDialog(false);
    };

    function handleUrlasserDialogVerifyClick(username, cause, initiator) {
        for (let [cluster_id, value] of Object.entries(values)) {
            try {
                if (autoModeActive[cluster_id]) {
                    changeBrightness({
                        variables: {id: cluster_id, brightness: -1, username: username, cause: cause, initiator: initiator},
                    });
                } else {
                    changeBrightness({
                        variables: {
                            id: cluster_id,
                            brightness: parseInt(value),
                            username: username,
                            cause: cause,
                            initiator: initiator,
                        },
                    });
                }
            } catch (e) {
                console.log(e);
            }
        }
        setOpenUrlasserDialog(false);
        onVerifyClick();
    }

    const handleVerifyClicked = () => {
        // setOpenUrlasserDialog(true);
        checkAuthorization(currentUserData, currentProject, document.getElementById('authentication_problem'), () => {
            setOpenUrlasserDialog(true);
        });
    };

    const handleAutoModeChange = event => {
        if (initialCheck) {
            setValues({...initialValues.current});
            setAutoModeActive({...initialChecks.current, [event.target.name]: event.target.checked});
        } else {
            setAutoModeActive({...autoModeActive, [event.target.name]: event.target.checked});
        }
        // console.log(autoModeActive)
        setInitialValue(false);
        setInitialCheck(false);
        // setAutoModeActive({ ...autoModeActive, [event.target.name]: event.target.checked });
    };

    const handleChange = name => event => {
        if (initialValue) {
            setAutoModeActive({...initialChecks.current});
            setValues({...initialValues.current, [name]: event.target.value});
        } else {
            setValues({...values, [name]: event.target.value});
        }
        // initialValues.current = {...initialValues.current, [name]: event.target.value}
        // console.log(name, initialValues.current[name], event.target.value)
        setInitialCheck(false);
        setInitialValue(false);
    };

    // const handleInitialValue = () => {};

    // const handleInitialCheck = () => {

    // };

    const handleClose = () => {
        setValues({});
        onClose();
    };
    // const test = allCluster.filter(cluster => {return (!cluster.name.includes("Blinker") && !cluster.name.includes("CB-Funk"))})
    return (
        <React.Fragment>
            <UrlasserDialog
                onVerifyClick={handleUrlasserDialogVerifyClick}
                onClose={handleUrlasserDialogClose}
                open={openUrlasserDialog}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Einstellung Helligkeit</DialogTitle>

                <DialogContent>
                    <Table size="medium" className="switchBrightnessTable">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>aktuell</TableCell>
                                <TableCell>Befehl</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allCluster
                                .filter(cluster => {
                                    return !cluster.name.includes('Blinker') && !cluster.name.includes('CB-Funk');
                                })
                                .map(cluster => (
                                    <Query query={GET_CLUSTER_DATA} variables={{id: cluster.id}} fetchPolicy="no-cache">
                                        {({data, error, loading}) => {
                                            if (data !== undefined && data.cluster !== undefined) {
                                                if (
                                                    data.cluster.cluster_state === undefined &&
                                                    data.cluster.cluster_command === undefined
                                                ) {
                                                    return null;
                                                }
                                                // if(values[cluster.id] === undefined) {
                                                if (data.cluster.cluster_command && data.cluster.cluster_command.brightness === -1) {
                                                    const min_value = cluster.name.includes('Hybrid') ? 6 : 0;
                                                    // setValues({ ...values, [cluster.id]: min_value });
                                                    // setAutoModeActive({ ...autoModeActive, [cluster.id]: true });
                                                    initialValues.current[cluster.id] = min_value;
                                                    initialChecks.current[cluster.id] = true;
                                                } else if (data.cluster.cluster_command) {
                                                    initialValues.current[cluster.id] = data.cluster.cluster_command.brightness;
                                                    initialChecks.current[cluster.id] = false;
                                                    // setValues({ ...values, [cluster.id]: data.cluster.cluster_command.brightness });
                                                    // setAutoModeActive({ ...autoModeActive, [cluster.id]: false });
                                                }
                                                // console.log(initialValues.current, initialChecks.current)
                                                // }
                                                return (
                                                    <TableRow key={cluster.name}>
                                                        <TableCell component="th" scope="row">
                                                            {cluster.name.includes('Hybrid')
                                                                ? cluster.name.replace('Clusterkanal', '')
                                                                : cluster.name.replace('Clusterkanal', 'MatrixRGB')}
                                                        </TableCell>
                                                        {data.cluster.cluster_state &&
                                                            (data.cluster.cluster_state.brightness < 0 ? (
                                                                <TableCell>N/A</TableCell>
                                                            ) : (
                                                                <TableCell>{data.cluster.cluster_state.brightness} %</TableCell>
                                                            ))}
                                                        <FormGroup row>
                                                            {/* {autoModeActive[cluster.id] !== undefined ?  */}
                                                            <FormControlLabel
                                                                className="autoModeCheckbox"
                                                                control={
                                                                    <Checkbox
                                                                        name={cluster.id}
                                                                        checked={
                                                                            initialCheck
                                                                                ? initialChecks.current[cluster.id]
                                                                                : autoModeActive[cluster.id]
                                                                        }
                                                                        onChange={handleAutoModeChange}
                                                                    />
                                                                }
                                                                label="auto"
                                                            />{' '}
                                                            : <React.Fragment />
                                                            {/* } */}
                                                            <TextField
                                                                disabled={
                                                                    initialCheck
                                                                        ? initialChecks.current[cluster.id]
                                                                        : autoModeActive[cluster.id]
                                                                }
                                                                className="brightnessTextField"
                                                                id="brightness command value"
                                                                value={
                                                                    initialValue
                                                                        ? initialValues.current[cluster.id]
                                                                        : values[cluster.id]
                                                                }
                                                                onChange={handleChange(cluster.id)}
                                                                type="number"
                                                                margin="normal"
                                                                inputProps={{
                                                                    min: cluster.name.includes('Hybrid') ? '6' : '0',
                                                                    max: '100',
                                                                    step: '1',
                                                                }}
                                                                InputProps={{
                                                                    endAdornment: <InputAdornment>%</InputAdornment>,
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </TableRow>
                                                );
                                            }
                                            return (
                                                <TableRow key={cluster.name}>
                                                    <TableCell component="th" scope="row">
                                                        {cluster.name.includes('Hybrid')
                                                            ? cluster.name.replace('Clusterkanal', '')
                                                            : cluster.name.replace('Clusterkanal', 'MatrixRGB')}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <CircularProgress className="loading" />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <CircularProgress className="loading" />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }}
                                    </Query>
                                ))}
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions>
                    <p id="authentication_problem" style={{color: 'red'}}></p>
                    <Button color="primary" onClick={handleClose}>
                        Abbrechen
                    </Button>
                    <Button color="primary" variant="contained" onClick={handleVerifyClicked}>
                        Übernehmen
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

SwitchBrightnessDialog.propTypes = {
    source: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onVerifyClick: PropTypes.func.isRequired,
};

export default SwitchBrightnessDialog;
